import { DispatchEquipAlerts } from "../../asset/DispatchEquipAlerts";
import { Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutDriverAlerts extends Layout {
    layoutDispatchEquipAlerts: DispatchEquipAlerts;
    tabEquipmentAlerts: Tab;
    tabsetAlerts: Tabset;
}
